import { isProductionEnv } from "@wevideo/platform/runtime/Environment";

export const PASSWORD_REQUIREMENTS = [
	{ key: "length", label: "At least 8 characters", regex: /.{8,}/ },
	{ key: "uppercase", label: "One uppercase letter", regex: /[A-Z]/ },
	{ key: "lowercase", label: "One lowercase letter", regex: /[a-z]/ },
	{ key: "number", label: "One number", regex: /[0-9]/ },
	{
		key: "special",
		label: "One special character",
		regex: /[!@#$%^&*()\-_=+[\]{};:'",./<>?\\|`~]/,
	},
];

export const getPasswordRequirements = (password: string) =>
	PASSWORD_REQUIREMENTS.map(({ key, label, regex }) => ({ key, label, met: regex.test(password) }));

export const isValidPassword = (password: string): boolean =>
	PASSWORD_REQUIREMENTS.every(({ regex }) => regex.test(password));

export const validatePasswordComplexity = (password: string): string | null => {
	const failed = PASSWORD_REQUIREMENTS.find(({ regex }) => !regex.test(password));
	return failed ? failed.label : null;
};

export const isValidPasswordForEnv = (password: string): boolean =>
	!isProductionEnv() || isValidPassword(password);
